import client from '../../../src/client/client.node';

import { searchSeoSuburbQuery } from '../../gql/search';
import locationUrl from '../../utils/locationUrl';

const checkSeoSuburbData = async params => {
  const { region, state } = params || {};
  const { data } = await client.query({
    query: searchSeoSuburbQuery,
    variables: {
      params: {
        suburb: region,
        state,
      },
    },
    errorPolicy: 'all',
  });
  const { searchSeoSuburb } = data || {};
  const { links } = searchSeoSuburb || {};
  const { breadcrumbs } = links || {};

  if (breadcrumbs && breadcrumbs.length) {
    return locationUrl({ breadcrumbs });
  }
  return '/';
};

const getEmptyDataRedirect = async (params, data, errors) => {
  if (errors && !data && params) {
    return checkSeoSuburbData(params);
  }
  return false;
};

const getBreadcrumbsRedirect = (params, data, pathname) => {
  if (!params) return false;
  if (!data) return false;
  if (!pathname) return false;

  const { links } = data;
  const { breadcrumbs } = links || {};

  if (!breadcrumbs) return false;
  const url = locationUrl({
    breadcrumbs,
  });
  if (url !== pathname) return url;

  return false;
};

const redirects = async ({
  params,
  data: searchSeoRegion,
  pathname,
  errors,
}) => {
  // const { searchSeoRegion } = data || {}; # REVERT GRAPHQL
  const emptyData = await getEmptyDataRedirect(params, searchSeoRegion, errors);
  const redirectArray = [
    emptyData,
    getBreadcrumbsRedirect(params, searchSeoRegion, pathname),
  ];

  return redirectArray.find(url => url);
};

export default redirects;
